<div class="field-wrapper" #fieldwrapper>
    <section class="routes-field-wrapper">
        <nz-card [nzBordered]="false" class="ant-card-body-main share-card-wrapper">
            <nz-col [nzXs]="24" [nzMd]="24" [nzLg]="24" [nzXl]="24">
                <h3 class="waec-card-header-text">{{'PROVISIONING.SHARE.HEADER' | translate}}</h3> <br />

                <digicert-radio-button [options]="shareCertificateOptions"
                    (onSelectOption)="selectedShareCertificateOption($event)"></digicert-radio-button>
                <br><br>
                <p class="span-left">{{'PROVISIONING.SHARE.SUBHEADER' | translate}}</p>

                <div nz-row [style]="" nzTitle="Certificate Sharing">
                    <div class="certificate_share_div" *ngIf="shareCertificateOptionSelected == shareOptions.INDIVIDUAL"
                        nz-col nzXs="24" nzSm="24" nzMd="20" nzLg="20" nzXl="18">
                        <form nz-form [formGroup]="shareForm">
                            <nz-col class="p-0">
                                <nz-form-item>
                                    <nz-col nzSpan="24">
                                        <nz-form-label nzRequired nzFor="certificate" nzRequired>
                                            {{'PROVISIONING.SHARE.SELECT_CERTIFICATE' | translate}}
                                        </nz-form-label>
                                    </nz-col>

                                    <nz-col nzSpan="24">
                                        <nz-form-control
                                            [nzErrorTip]="'PROVISIONING.SHARE.PLEASE_SELECT_CERTIFICATE' | translate">
                                            <nz-select nzShowSearch nzAllowClear id="certificate"
                                                formControlName="certificate"
                                                [nzPlaceHolder]="'PROVISIONING.SHARE.SELECT_YOUR_CERTIFICATE' | translate"
                                                (ngModelChange)="certificateView($event)">
                                                <nz-option *ngFor="let i of certificateList" [nzLabel]="i.new_name"
                                                    [nzValue]="i.id"></nz-option>
                                            </nz-select>
                                        </nz-form-control>
                                    </nz-col>
                                </nz-form-item>
                            </nz-col>

                            <div *ngIf="showCertificate">
                                <digicert-waec-certificate-card
                                    [selectedCertificate]="selectedCertificate"></digicert-waec-certificate-card>
                            </div>

                            <nz-col class="certificate_share_div p-0">
                                <nz-form-item class="pt-2">
                                    <nz-col nzSpan="24">
                                        <nz-form-label nzRequired
                                            nzFor="receiversemail">{{'PROVISIONING.SHARE.RECEIVER_EMAIL' |
                                            translate}}</nz-form-label>
                                    </nz-col>

                                    <nz-col nzSpan="24">
                                        <nz-form-control [nzErrorTip]="'PROVISIONING.SHARE.EMAIL_ERROR' | translate">
                                            <nz-input-group nzSize="large" nzPrefixIcon="mail">
                                                <input nz-input name="recieversemail" id="recieversemail"
                                                    formControlName="email"
                                                    [placeholder]="'PROVISIONING.SHARE.ENTER_EMAIL' | translate" />
                                            </nz-input-group>
                                        </nz-form-control>
                                    </nz-col>
                                </nz-form-item>
                            </nz-col>

                            <nz-col>
                                <nz-form-item class="mt-6">
                                    <nz-col [nzSm]="17">
                                        <nz-form-control>
                                            <button nz-button nzType="primary" nzSize="large"
                                                [disabled]="!shareForm?.valid" (click)="submit()">
                                                {{'PROVISIONING.SHARE.SUBMIT_BTN' | translate | uppercase}}
                                            </button>
                                        </nz-form-control>
                                    </nz-col>
                                </nz-form-item>
                            </nz-col>
                        </form>
                    </div>

                    <div class="certificate_share_div"
                        *ngIf="shareCertificateOptionSelected == shareOptions.REQUEST_CONFIRMATION" nz-col nzXs="24"
                        nzSm="24" nzMd="24" nzLg="20" nzXl="18">
                        <form nz-form [formGroup]="shareToInstitutionForm" (ngSubmit)="shareCertToInstitution()">
                            <nz-col class="p-0">
                                <nz-form-item>
                                    <nz-col nzSpan="24">
                                        <nz-form-label nzRequired nzFor="certificate_"
                                            nzRequired>{{'PROVISIONING.SHARE.SELECT_CERTIFICATE' |
                                            translate}}</nz-form-label>
                                    </nz-col>
                                    <nz-col nzSpan="24">
                                        <nz-form-control
                                            [nzErrorTip]="'PROVISIONING.SHARE.PLEASE_SELECT_CERTIFICATE' | translate">
                                            <nz-select nzShowSearch nzAllowClear formControlName="certificate_"
                                                [nzPlaceHolder]="'PROVISIONING.SHARE.SELECT_YOUR_CERTIFICATE' | translate"
                                                (ngModelChange)="certificateView_($event)">
                                                <nz-option *ngFor="let i of certificateList" [nzLabel]="i.new_name"
                                                    [nzValue]="i.id">
                                                </nz-option>
                                            </nz-select>
                                        </nz-form-control>
                                    </nz-col>
                                </nz-form-item>
                            </nz-col>

                            <div *ngIf="showCertificate_">
                                <digicert-waec-certificate-card
                                    [selectedCertificate]="selectedCertificate_"></digicert-waec-certificate-card>
                            </div>

                            <div *ngIf="!isInstitutionNotAvailable">
                                <nz-col class="certificate_share_div p-0">
                                    <nz-form-item class="pt-2">
                                        <nz-col nzSpan="24">
                                            <nz-form-label nzRequired
                                                nzFor="institution">{{'PROVISIONING.SHARE.SELECT_INSTITUTION' |
                                                translate}}</nz-form-label>
                                        </nz-col>

                                        <nz-col nzSpan="24">
                                            <nz-form-control
                                                [nzErrorTip]="'PROVISIONING.SHARE.PLEASE_SELECT_INSTITUTION' | translate">
                                                <nz-select nzShowSearch nzServerSearch nzAllowClear
                                                    formControlName="institution_user_id" id="institution"
                                                    [nzPlaceHolder]="'PROVISIONING.SHARE.SEARCH_BY_INSTITUTION' | translate"
                                                    [nzAllowClear]="true" [nzDisabled]="!this.showCertificate_"
                                                    (nzOnSearch)="searchForEmailInstitution($event)"
                                                    (ngModelChange)="onSelectInstitution($event)">

                                                    <ng-container *ngFor="let i of emailInstitutionList">
                                                        <nz-option nzCustomContent
                                                            *ngIf="!isInstitutionLoading && emailInstitutionList.length"
                                                            [nzLabel]="(i?.email || i?.account_name.trim().length) ? (i.name || i?.account_name) + ' (' +  (i?.email || i?.account_name) + ')' : i?.name"
                                                            [nzValue]="i?.id">
                                                            <span>{{(i?.email || i?.account_name.trim().length) ?
                                                                (i?.name || i?.account_name) + ' (' + (i?.email ||
                                                                i?.account_name) + ')' : i?.name}}</span>
                                                        </nz-option>
                                                    </ng-container>


                                                    <nz-option *ngIf="isInstitutionLoading" nzDisabled nzCustomContent>
                                                        <span nz-icon nzType="loading" class="loading-icon"></span>
                                                        {{'PROVISIONING.SHARE.LOADING_DATA' | translate}}
                                                    </nz-option>
                                                </nz-select>
                                            </nz-form-control>
                                        </nz-col>
                                    </nz-form-item>
                                </nz-col>

                                <nz-col *ngIf="isAddressNotAvailable" nzSpan="24">
                                    <nz-form-item class="pt-2">
                                        <nz-col nzSpan="24">
                                            <nz-form-label nzRequired
                                                nzFor="address">{{'PROVISIONING.SHARE.INSTITUTION_ADDRESS_LABEL' |
                                                translate}}</nz-form-label>
                                        </nz-col>

                                        <nz-col nzSpan="24">
                                            <nz-form-control
                                                [nzErrorTip]="'PROVISIONING.SHARE.INSTITUTION_ADDRESS_ERROR' | translate">
                                                <textarea nz-input name="address" id="address"
                                                    formControlName="verify_address"
                                                    [placeholder]="'PROVISIONING.SHARE.INSTITUTION_ADDRESS_PLACEHOLDER' | translate"></textarea>
                                            </nz-form-control>
                                        </nz-col>
                                    </nz-form-item>
                                </nz-col>
                            </div>

                            <nz-col nzSpan="24" class="mt-4px">
                                <div nz-row nzJustify="start" nzAlign="middle">
                                    <div nz-col nzSpan="24">
                                        <nz-switch #switch formControlName="switch" [nzSize]="'small'"
                                            (ngModelChange)="onToggleSwitch(switch.isChecked)"></nz-switch> &nbsp;

                                        <span class="span-left">{{ institutionAvailablityInfo | translate}}</span>
                                    </div>
                                </div>
                            </nz-col>

                            <div *ngIf="isInstitutionNotAvailable">
                                <nz-col class="certificate_share_div p-0">
                                    <nz-form-item class="pt-2">
                                        <nz-col nzSpan="24">
                                            <nz-form-label nzRequired
                                                nzFor="institution">{{'PROVISIONING.SHARE.INSTITUTION' |
                                                translate}}</nz-form-label>
                                        </nz-col>
                                        <nz-col nzSpan="24">
                                            <nz-form-control
                                                [nzErrorTip]="'PROVISIONING.SHARE.INSTITUTION_NAME_ERROR' | translate">
                                                <input nz-input name="institution" id="institution"
                                                    formControlName="institution"
                                                    [placeholder]="'PROVISIONING.SHARE.INSTITUTION_NAME_PLACEHOLDER' | translate" />
                                            </nz-form-control>
                                        </nz-col>
                                    </nz-form-item>
                                </nz-col>

                                <nz-col class="certificate_share_div p-0">
                                    <nz-form-item class="pt-2">
                                        <nz-col nzSpan="24">
                                            <nz-form-label nzRequired
                                                nzFor="institutionemail">{{'PROVISIONING.SHARE.INSTITUTION_EMAIL' |
                                                translate}}</nz-form-label>
                                        </nz-col>
                                        <nz-col nzSpan="24">
                                            <nz-form-control
                                                [nzErrorTip]="'PROVISIONING.SHARE.INSTITUTION_EMAIL_ERROR' | translate">
                                                <nz-input-group nzSize="large" nzPrefixIcon="mail">
                                                    <input nz-input name="institutionemail" id="institutionemail"
                                                        formControlName="institutionemail"
                                                        [placeholder]="'GENERAL.ENTER_INSTITUTION_EMAIL' | translate" />
                                                </nz-input-group>
                                            </nz-form-control>
                                        </nz-col>
                                    </nz-form-item>
                                </nz-col>

                                <nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                                    <nz-form-label nzRequired nzFor="institution_country">{{'GENERAL.SELECT_COUNTRY' |
                                        translate}}</nz-form-label>
                                    <nz-form-item>
                                        <nz-form-control
                                            [nzErrorTip]="'PROVISIONING.SHARE.SELECT_COUNTRY_ERROR' | translate"
                                            nzSpan="24">
                                            <nz-select nzAllowClear formControlName="country"
                                                [nzPlaceHolder]="'PROVISIONING.SHARE.SELECT_COUNTRY_PLACEHOLDER' | translate"
                                                name="country" id="institution_country"
                                                [nzCustomTemplate]="countrySelection">
                                                <nz-option *ngFor="let data of countries" [nzValue]="data.code"
                                                    [nzLabel]="data.name">
                                                </nz-option>
                                            </nz-select>

                                            <ng-template #countrySelection let-selected>
                                                <img class="selected_country" alt="{{ selected.nzLabel }}" src="https://purecatamphetamine.github.io/country-flag-icons/3x2/{{
                                                            selected.nzValue
                                                        }}.svg" height="20" width="20" />
                                                {{ selected.nzLabel }}
                                            </ng-template>
                                        </nz-form-control>
                                    </nz-form-item>
                                </nz-col>

                                <nz-col class="certificate_share_div p-0">
                                    <nz-form-item class="pt-2">
                                        <nz-col nzSpan="24">
                                            <nz-form-label nzRequired
                                                nzFor="address">{{'PROVISIONING.SHARE.INSTITUTION_ADDRESS_LABEL' |
                                                translate}}</nz-form-label>
                                        </nz-col>
                                        <nz-col nzSpan="24">
                                            <nz-form-control
                                                [nzErrorTip]="'PROVISIONING.SHARE.INSTITUTION_ADDRESS_ERROR' | translate">
                                                <textarea nz-input name="address" id="address" formControlName="address"
                                                    [placeholder]="'PROVISIONING.SHARE.INSTITUTION_ADDRESS_PLACEHOLDER' | translate"></textarea>
                                            </nz-form-control>
                                        </nz-col>
                                    </nz-form-item>
                                </nz-col>
                            </div>

                            <nz-col class="certificate_share_div p-0">
                                <nz-form-item class="pt-2">
                                    <nz-col nzSpan="24">
                                        <nz-form-label nzFor="additional_info">
                                            {{'PROVISIONING.SHARE.ADDITIONAL_INFO' | translate}}
                                        </nz-form-label>
                                    </nz-col>

                                    <nz-col nzSpan="24">
                                        <nz-form-control>
                                            <textarea nz-input name="additional_info" id="additional_info"
                                                formControlName="additional_info"
                                                [placeholder]="'PROVISIONING.SHARE.ADDITIONAL_INFO_PLACEHOLDER' | translate"></textarea>
                                        </nz-form-control>
                                    </nz-col>
                                </nz-form-item>
                            </nz-col>

                            <nz-col class="certificate_share_div p-0">
                                <nz-form-item class="mt-6">
                                    <nz-col [nzSm]="17">
                                        <nz-form-control>
                                            <button nz-button nzType="primary" nzSize="large"
                                                [disabled]="checkInstitutionFormvaldity">
                                                {{'PROVISIONING.SHARE.SUBMIT_BTN' | translate | uppercase}}
                                            </button>
                                        </nz-form-control>
                                    </nz-col>
                                </nz-form-item>
                            </nz-col>
                        </form>
                    </div>
                </div>
            </nz-col>
        </nz-card>
    </section>


    <span class="d-none">{{scrollToHistory}}</span>
    <section #shareHistory class="shared-history-wrapper">
        <nz-card [nzBordered]="false" class="ant-card-body-main share-card-wrapper">
            <div nz-col [nzXl]="24" class="share-history-card-header">
                <h3>{{'PROVISIONING.SHARE.HISTORY_HEADER' | translate}}</h3>
                <a class="share-history-link" (click)="onViewMoreHistory()">{{'PROVISIONING.SHARE.VIEW_MORE' |
                    translate}}</a>
            </div>

            <div *ngIf="isSkeleton">
                <nz-skeleton-element *ngFor="let item of sharedHistorySkeleton" nzType="input" [nzActive]="true"
                    [nzSize]="'large'" class="skeleton"></nz-skeleton-element>
            </div>

            <div *ngIf="sharedHistory.length">
                <figure class="info-card" *ngFor="let detail of sharedHistory"
                    [ngClass]="detail?.status.toLowerCase() == shareStatuses.SUCCESSFUL ? '' : 'share-unsuccessful'">
                    <div class="timestamp">
                        {{ detail?.created_at | date : pipeDateFormart }} <br *ngIf="!isSmallScreen">
                        {{detail?.created_at | date : 'h:mm a'}}
                    </div>

                    <div class="history-user-detail">
                        <p>
                            <span class="candidate">
                                {{detail?.candidate?.surname | titlecase}}
                                {{detail?.candidate?.firstname | titlecase}}
                            </span> |
                            <span class="exam-year">{{detail?.candidate?.year}} </span>
                        </p>
                        <small class="share-type">
                            <svg-icon [src]="getShareTypeIcon(detail?.share_type)" [applyClass]="true"
                                [svgClass]="'share-type-icon'"></svg-icon>
                            {{ detail?.share_type === shareType.INSTITUTION? ('PROVISIONING.SHARE.INSTITUTION' |
                            translate | titlecase) : ('PROVISIONING.SHARE.INDIVIDUAL' | translate) }}
                        </small>
                        <small>{{detail?.email}}</small>
                    </div>

                    <div class="history-status">
                        <svg-icon [src]="
                                detail.status.toLowerCase() == shareStatuses.SUCCESSFUL ?
                                'assets/v2/icons/check-circle.svg' : 'assets/v2/icons/x-circle.svg'
                            " [applyClass]="true" [svgClass]="share-status-icon"></svg-icon>
                    </div>
                </figure>
            </div>

            <div class="scroll-to-top-wrapper">
                <div *ngIf="displayScrollToTop" class="scroll-to-top" (click)="scrollToTop()">
                    <p>{{'PROVISIONING.SHARE.SCROLL_TOP' | translate}}</p>
                    <svg-icon src="assets/v2/icons/ei_arrow-up.svg" [applyClass]="true"
                        [svgClass]="'scroll-to-top-icon'"></svg-icon>
                </div>
            </div>
        </nz-card>
    </section>
</div>

<!-- Wallet Credit -->
<nz-modal [nzStyle]="{top: '20px'}" [nzMask]="true" nzMaskClosable="false" nzWidth="400px" nzClosable="true"
    [(nzVisible)]="walletCreditModal" [nzTitle]="'GENERAL.FUND_WALLET' | translate"
    [nzContent]="modalContentbillingpayment" (nzOnCancel)="cancelmodalContentbillingpayment()">
    <ng-template #modalContentbillingpayment>
        <app-billing-modal (successResponse)="initiateFundingWallet()" [Cost]="getCost()"></app-billing-modal>
    </ng-template>
    <div *nzModalFooter></div>
</nz-modal>

<!-- MODE OF PAYMENT Information -->
<app-payment *ngIf="paymentModal" (closeModal)="cancelPaymentOptionsModal()" (confirmSubmit)="initiateWallet($event)"
    [action]="services.SHARE" [Cost]="getCost()"></app-payment>

<!-- SERVICE CHARGE / INFORMATION CONFIRMATION MODAL -->
<digicert-service-charge *ngIf="userInformationModal" [candidateInformationForm]="candidateInformation"
    [serviceCharge]="serviceCharge" [costInUnit]="costInUnit" [feature]="services.SHARE"
    (closeModal)="closeConfirmInformation()" (makePayment)="checkBalanceInitiatePayment();"></digicert-service-charge>


<!-- PROCESS FLOW MODAL -->
<digicert-process-steps *ngIf="processStepsModal" [feature]="services.SHARE" [serviceCharge]="serviceCharge"
    [costInUnit]="costInUnit" [userType]="userTypes.USER" [steps]="step" [candidateInformation]="candidateInformation"
    (successfulFlow)="confirmSubmission()" (withdrawFromWallet)="confirmSubmission()"
    (closeModal)="closeProcessStepsModal()"></digicert-process-steps>

    
<!-- EXAM COUNTRY SETUP MODAL -->
<app-exam-country-setup *ngIf="examCountrySetupModal"
  (closeModal)="closeExamCountrySetupModal()"></app-exam-country-setup>